import { ExternalLookupTypeDTO } from '@/api/base/DTOs';
import { ExternalLookupType } from '@/typings';

export const adaptExternalLookupTypeResponseToExternalLookupType = (
  externalLookupTypeResponse: ExternalLookupTypeDTO,
): ExternalLookupType => {
  switch (externalLookupTypeResponse) {
    case ExternalLookupTypeDTO.None:
      return ExternalLookupType.None;
    case ExternalLookupTypeDTO.Address:
      return ExternalLookupType.Address;
    case ExternalLookupTypeDTO.CityStateCountry:
      return ExternalLookupType.CityStateCountry;
    case ExternalLookupTypeDTO.Facility:
      return ExternalLookupType.Facility;
    case ExternalLookupTypeDTO.License:
      return ExternalLookupType.License;
    case ExternalLookupTypeDTO.Education:
      return ExternalLookupType.Education;
    case ExternalLookupTypeDTO.BoardCertification:
      return ExternalLookupType.BoardCertification;
    case ExternalLookupTypeDTO.DEALicense:
      return ExternalLookupType.DEALicense;
    case ExternalLookupTypeDTO.FacilityAddress:
      return ExternalLookupType.FacilityAddress;
  }
};
